import { Box, Container } from '@mui/joy';
import { useSeoHead } from '../../../hooks/service/useSeoHead';
import { WelcomeHeader } from './WelcomeHeader';
import { HeroSection } from './HeroSection';
import { FeaturesSection } from './FeaturesSection';
import { MicroblogSection } from './MicroblogSection';
import { MessengerSection } from './MessengerSection';
import { CallSection } from './CallSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ContactsSection } from './ContactsSection';
import { DownloadSection } from './DownloadSection';
import { FooterSection } from './FooterSection';
import { FaqSection } from './FaqSection';
import { SecuritySection } from './SecuritySection';
import { WhyAquariumSection } from './WhyAquariumSection';
import { ReviewsSection } from './ReviewsSection';
import { useMediaQuery } from '@mui/material';

const SITE_URL = 'https://aquarium.org.ru';

const WELCOME_TITLE = 'Аквариум — мессенджер и микроблог в одном приложении';
const WELCOME_DESCRIPTION = 'Аквариум — спокойное пространство для общения: личные и групповые чаты, аудио- и видеозвонки и лента записей без алгоритмов и рекламы. Веб-версия, iOS и Android.';
const WELCOME_URL = `${SITE_URL}/welcome`;
const WELCOME_IMAGE = `${SITE_URL}/web-app-manifest-512x512.png`;

const WELCOME_JSONLD = {
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'Organization',
            '@id': `${SITE_URL}/#organization`,
            name: 'Аквариум',
            url: SITE_URL,
            logo: WELCOME_IMAGE,
            sameAs: ['https://t.me/aquariumsocial'],
        },
        {
            '@type': 'WebSite',
            '@id': `${SITE_URL}/#website`,
            url: SITE_URL,
            name: 'Аквариум',
            inLanguage: 'ru-RU',
            publisher: { '@id': `${SITE_URL}/#organization` },
        },
        {
            '@type': 'SoftwareApplication',
            name: 'Аквариум',
            applicationCategory: 'CommunicationApplication',
            operatingSystem: 'Web, iOS, Android',
            description: WELCOME_DESCRIPTION,
            url: WELCOME_URL,
            offers: { '@type': 'Offer', price: '0', priceCurrency: 'RUB' },
        },
    ],
};

export default function PageWelcome() {
    const isSmall = useMediaQuery('(max-width: 600px)');

    useSeoHead({
        title: WELCOME_TITLE,
        description: WELCOME_DESCRIPTION,
        canonical: WELCOME_URL,
        image: WELCOME_IMAGE,
        og: { 'og:type': 'website', 'og:site_name': 'Аквариум', 'og:locale': 'ru_RU' },
        twitter: { 'twitter:card': 'summary_large_image' },
        jsonLd: WELCOME_JSONLD,
    });

    return (
        <>
            <Box component="main" sx={{ display: 'flex', flexDirection: 'column' }}>
                <WelcomeHeader />
                <HeroSection />
                <FeaturesSection />
                <MicroblogSection />
                <MessengerSection />
                <CallSection />
                <HowItWorksSection />
                <WhyAquariumSection />
                <SecuritySection />
                <ReviewsSection />
                <FaqSection />
                <DownloadSection />
                <ContactsSection />
            </Box>
            <Box sx={{ pb: isSmall ? '6rem' : '0px' }}>
                <FooterSection />
            </Box>
        </>
    );
}
